<div class="row" #rowContainer>
  <div class="col-12">
    <form [formGroup]="estimateForm">
      <div class="p-2">
        <div
          class="currency-container mb-3"
          *ngIf="loginType !== 'CUSTOMER' && forTransactionPage"
        >
          <div *ngIf="isLoading" class="top-spinner text-end">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div class="row">
            <ng-container *ngIf="forTransactionPage">
              <div
                [class.col-12]="isWideScreen"
                [class.col-12]="!isWideScreen"
                class="common-select"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <label for="customerUserId">Customer </label>
                </div>
                <ng-select
                  [items]="customer$ | async"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="customerUserId"
                  [typeahead]="customerSearch$"
                  [virtualScroll]="true"
                  id="customerUserId"
                  [placeholder]="
                    loginType == 'PARTNER' ? 'Search ...' : 'Select Customer'
                  "
                  (change)="getCustomerValue($event)"
                  [clearable]="true"
                >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.name }}
                    <span *ngIf="item.mobileNumber"
                      >({{ item.mobileNumber }})</span
                    >
                    <span *ngIf="item.customerUserCode"
                      >({{ item.customerUserCode }})</span
                    >
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span
                      class="ng-value-label"
                      *ngIf="item.value || item.customerUserCode"
                      >{{ item.name }}
                      <span *ngIf="item.mobileNumber"
                        >({{ item.mobileNumber }})</span
                      >
                      <span *ngIf="item.customerUserCode"
                        >({{ item.customerUserCode }})</span
                      >
                    </span>
                  </ng-template>
                </ng-select>
              </div>
              <div
                [class.col-12]="isWideScreen"
                [class.col-12]="!isWideScreen"
                class="common-select"
                *ngIf="loginType.toLowerCase() == 'partner'"
              >
                <div class="partner-create-buttons">
                  <button
                    class="btn btn-primary"
                    (click)="createInNewTab('customer')"
                  >
                    Create Customer
                  </button>
                  <a
                    (click)="gotoDocumentPage()"
                    class="link-custom-primary ms-2"
                    href="javascript:void(0);"
                    *ngIf="
                      documentUpload &&
                      estimateForm.controls['customerUserId'].value
                    "
                  >
                    View Document
                  </a>
                </div>
              </div>
              <!-- moving receiver section -->
              <div
                [class.col-12]="isWideScreen"
                [class.col-12]="!isWideScreen"
                class="common-select"
              >
                <label for="receiverUserId"> Receiver</label>
                <ng-select
                  [items]="receiver$ | async"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="receiverUserId"
                  [virtualScroll]="false"
                  [typeahead]="receiverSearch$"
                  (scrollToEnd)="receiverScroll()"
                  id="receiverUserId"
                  placeholder="Select Receiver"
                  (change)="getReceiverValue($event)"
                  [clearable]="true"
                  [virtualScrollItemSize]="40"
                >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="flex items-center gap-2">
                      <span>
                        {{ item.name }} ({{ item.customerUserCode }})
                        <ng-container *ngIf="item.paymentDetails">
                          <div
                            class="row ms-1"
                            *ngFor="
                              let data of item.paymentDetails;
                              let i = index
                            "
                            [ngClass]="
                              item.paymentDetails.length > i + 1
                                ? 'border-bottom'
                                : 'none'
                            "
                            id="o_{{ data.id }}"
                          >
                            <div class="col-md-12 mb-1">
                              <strong class="text-muted fs-12 mb-0 me-2"
                                >{{ data?.label }} &nbsp;&nbsp;
                                {{
                                  data?.paymentDetailsSchema
                                    ?.modeOfPaymentOrPayout
                                }}</strong
                              >
                            </div>
                            <div class="col-md-12">
                              <app-show-field-schema-value
                                *ngIf="item.paymentDetails && !item.loading"
                                [displayList]="data.fieldSchemaValues"
                                [skipHeader]="true"
                                [skinpHeading]="true"
                              >
                              </app-show-field-schema-value>
                            </div>
                          </div>
                        </ng-container>
                      </span>
                      <span
                        class="spinner-border text-primary"
                        role="status"
                        *ngIf="item.loading"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </span>
                    </div>
                  </ng-template>

                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span
                      class="ng-value-label"
                      *ngIf="item.value || item.customerUserCode"
                      >{{ item.name }} ({{ item.customerUserCode }})</span
                    >
                  </ng-template>
                </ng-select>
              </div>
              <div
                [class.col-12]="isWideScreen"
                [class.col-12]="!isWideScreen"
                class="common-select"
                *ngIf="loginType.toLowerCase() == 'partner'"
              >
                <div class="partner-create-buttons">
                  <button
                    class="btn btn-primary"
                    (click)="createInNewTab('receiver')"
                  >
                    Create Receiver
                  </button>
                  <button
                    class="btn btn-primary ms-2"
                    (click)="gotoReceiverDetails('details')"
                  >
                    View Receiver
                  </button>
                </div>
              </div>
              <!-- <div class="payment-details col-12" *ngIf="paymentDetailsData.length > 0">
                <label for="paymentDetails">Payment Details : </label>
                <ng-select
                  [items]="paymentDetailsData"
                  bindLabel="detailLabel"
                  bindValue="id"
                  formControlName="paymentDetailsValueId"
                  [virtualScroll]="true"
                  id="paymentDetailsValueId"
                  placeholder="Select Payment Details">
                  <ng-template ng-label-tmp let-item="item">
                    <div class="line"> {{ item.label }} </div>
                    <div class="line"> Country: {{ item.fieldSchemaValues[0].value }} </div>
                    <div class="line"> Payment Mode: {{ item.paymentDetailsSchema.modeOfPaymentOrPayout }} </div>
                  </ng-template>
                </ng-select>
              </div> -->
              <div
                class="common-select"
                [class.col-6]="isWideScreen"
                [class.col-12]="!isWideScreen"
              >
                <label for="inGressCountryISO3"> Sending Country </label>
                <ng-select
                  [items]="countryIngressList"
                  bindLabel="officialName"
                  bindValue="alpha3"
                  formControlName="inGressCountryISO3"
                  [virtualScroll]="true"
                  id="inGressCountryISO3"
                  placeholder="Select Country"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.alpha3 }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.officialName }}
                  </ng-template>
                </ng-select>
              </div>
              <div
                class="common-select"
                [class.col-6]="isWideScreen"
                [class.col-12]="!isWideScreen"
              >
                <label for="Country"> Receiving Country</label>
                <ng-select
                  [items]="countryEgressList"
                  bindLabel="officialName"
                  bindValue="alpha3"
                  formControlName="eGressCountryISO3"
                  [virtualScroll]="true"
                  id="Country"
                  placeholder="Select Country"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.alpha3 }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.officialName }}
                  </ng-template>
                </ng-select>
              </div>
              <div
                class="common-select"
                [class.col-6]="isWideScreen"
                [class.col-12]="!isWideScreen"
              >
                <label for="modeOfPayoutName"> Mode Of Payout</label>
                <ng-select
                  [items]="modeOfPayoutList"
                  bindLabel="name"
                  bindValue="name"
                  formControlName="modeOfPayoutName"
                  [virtualScroll]="true"
                  id="modeOfPayoutName"
                  placeholder="Select Mode Of Payout"
                  (change)="getPayoutValue($event)"
                >
                </ng-select>
              </div>
            </ng-container>
          </div>
          <div class="row">
            <div class="mt-3" *ngIf="estimateDetails?.inGressCountryISO3">
              <strong>Sending Country :</strong>
              {{ estimateDetails.inGressCountryISO3 }}
            </div>
            <div class="mt-3" *ngIf="estimateDetails?.egressCountryISO3">
              <strong>Receiving Country :</strong>
              {{ estimateDetails.egressCountryISO3 }}
            </div>
          </div>
        </div>
        <div class="currency-container">
          <div class="side-by-side-container">
            <div class="rate-info rate-section">
              <div
                class="rate-box"
                *ngIf="
                  estimateForm.controls['inGressCurrencyISO3'].value &&
                  estimateForm.controls['eGressCurrencyISO3'].value
                "
              >
                1 {{ estimateForm.controls["inGressCurrencyISO3"].value }} =
                {{
                  estimateDetails?.resultFx
                    ? (estimateDetails?.resultFx | customDecimalFormat)
                    : 0
                }}
                {{ estimateForm.controls["eGressCurrencyISO3"].value }}
              </div>
            </div>
            <div *ngIf="isLoading" class="spinner-box text-end mb-2">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <ng-container *ngIf="forTransactionPage">
            <div class="mt-3">
              <div
                class="tri-toggle"
                [ngClass]="{
                  disabled:
                    estimateForm.get('calculateChargeExclusive')?.disabled ||
                    isToggleDisabled
                }"
              >
                <div
                  class="toggle-option"
                  [class.active]="
                    estimateForm.get('calculateChargeExclusive')?.value === true
                  "
                  (click)="!isToggleDisabled && setState(true)"
                >
                  Charge Exclusive
                </div>
                <div
                  class="toggle-option"
                  [class.active]="
                    estimateForm.get('calculateChargeExclusive')?.value ===
                    false
                  "
                  (click)="!isToggleDisabled && setState(false)"
                >
                  Charge Inclusive
                </div>
              </div>
            </div>
          </ng-container>

          <label>Amount </label>
          <div
            class="input-group"
            [ngClass]="
              estimateForm.controls['wantToCheckFromReceiverSide'].value ===
              false
                ? 'input-group-highlight'
                : ''
            "
          >
            <input
              type="number"
              class="amount-input"
              value=""
              formControlName="amount"
              (input)="onAmountInput($event)"
              id="amount"
            />
            <ng-select
              [items]="currencyIngressList"
              bindLabel="knownName"
              bindValue="code"
              formControlName="inGressCurrencyISO3"
              [virtualScroll]="true"
              [clearable]="false"
              id="currencyIngress"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.code }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.knownName }}
              </ng-template>
            </ng-select>
          </div>

          <label>Recipient gets</label>
          <div
            class="input-group"
            [ngClass]="
              estimateForm.controls['wantToCheckFromReceiverSide'].value
                ? 'input-group-highlight'
                : ''
            "
          >
            <input
              type="number"
              class="amount-input"
              value=""
              formControlName="receiveAmount"
              (input)="onReceiverAmountInput($event)"
            />
            <!-- [value]="(estimateDetails?.payoutAmount | number : '1.2-2') ?? 0" -->

            <ng-select
              [items]="currencyEgressList"
              bindLabel="knownName"
              bindValue="code"
              formControlName="eGressCurrencyISO3"
              [virtualScroll]="true"
              [clearable]="false"
              id="currencyEgress"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.code }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.knownName }}
              </ng-template>
            </ng-select>
          </div>

          <div class="info-summary" *ngIf="estimateDetails">
            <div class="info-row">
              <span class="label">To Send:</span>
              <span class="value">
                {{
                  estimateDetails.amount
                    | currency
                      : estimateDetails.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2"
                }}
              </span>
            </div>

            <div class="info-row">
              <span class="label">Charge:</span>
              <span class="value">
                {{
                  estimateDetails.totalCharge
                    | currency
                      : estimateDetails.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2"
                }}
              </span>
            </div>

            <div class="info-row total">
              <span class="label">Total to Pay:</span>
              <span class="value">
                {{
                  estimateDetails.amount + estimateDetails.totalCharge
                    | currency
                      : estimateDetails.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2"
                }}
              </span>
            </div>
          </div>

          <ng-container *ngIf="forTransactionPage">
            <label>Paying with</label>
            <div
              class="bank-transfer-box"
              (click)="openModal(estimateModal, 'payment')"
              id="modeOfPayment"
            >
              <div>
                <span class="bank-icon me-3 d-none d-sm-inline">🏦</span>
                <span class="bank-text">{{
                  estimateForm.controls["modeOfPayment"].value?.replace(
                    "_",
                    " "
                  ) | titlecase
                }}</span>
              </div>
              <button type="button" class="change-btn">Change</button>
            </div>

            <div class="row align-items-center">
              <div class="col-sm-12 col-md-4">
                <label>Receiver Details </label>
              </div>
              <div class="col-sm-12 col-md-8">
                <div
                  class="customer-create-buttons"
                  *ngIf="loginType == 'CUSTOMER' || loginType == 'PARTNER'"
                >
                  <button
                    class="btn btn-primary btn-sm"
                    (click)="createInNewTab('receiver')"
                  >
                    Create Receiver
                  </button>
                  <button
                    class="btn btn-primary btn-sm ms-2"
                    (click)="gotoReceiverDetails('details')"
                  >
                    View Receiver
                  </button>
                </div>
              </div>
            </div>

            <div class="bank-transfer-box p-0">
              <div
                class="ng-select w-50"
                (click)="openModal(estimateModal, 'receiver')"
                style="padding: 12px 14px"
                id="receiver"
              >
                <span class="bank-text">
                  <span
                    *ngIf="estimateForm.controls['receiverUserName']?.value"
                  >
                    {{ estimateForm.controls["receiverUserName"].value }}
                  </span>
                  <span
                    class="text-muted font-size-13 fw-medium"
                    *ngIf="!estimateForm.controls['receiverUserName']?.value"
                    >Receiver Name{{
                      estimateForm.controls["receiverUserName"].value
                    }}</span
                  >
                  <span class="ng-arrow-wrapper ms-4"
                    ><span class="ng-arrow"></span
                  ></span>
                </span>
              </div>
              <div
                class="w-50 text-end"
                (click)="openModal(estimateModal, 'payout')"
                style="padding: 12px 14px"
                id="modeOfPayout"
              >
                <span class="bank-icon me-3">🏦</span>
                <span class="bank-text">{{
                  estimateForm.controls["modeOfPayout"].value?.replace("_", " ")
                    | titlecase
                }}</span>
              </div>
            </div>

            <div
              class="row align-items-center"
              *ngIf="estimateForm.controls['receiverUserName']?.value"
            >
              <div class="col-sm-12 col-md-4">
                <label>Relationship </label>
              </div>
            </div>

            <div
              class="bank-transfer-box p-0"
              style="cursor: default"
              *ngIf="estimateForm.controls['receiverUserName']?.value"
            >
              <div class="ng-select w-100" style="padding: 12px 14px">
                <span class="bank-text">
                  {{ estimateForm.controls["relationship"]?.value }}
                </span>
              </div>
            </div>

            <ng-container
              *ngIf="loginType == 'PARTNER' || loginType == 'CUSTOMER'"
            >
              <div *ngIf="paymentDetailsData.length > 0">
                <label>Payment Details </label>
                <div class="payment-details-customer" id="paymentDetail">
                  <ng-select
                    [items]="paymentDetailsData"
                    bindLabel="detailLabel"
                    bindValue="id"
                    formControlName="paymentDetailsValueId"
                    [virtualScroll]="true"
                    id="paymentDetails"
                    placeholder="Select Payment Details"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <div class="line">{{ item.label }}</div>
                      <div class="line">
                        Country: {{ item?.fieldSchemaValues[0].value }}
                      </div>
                      <div class="line">
                        Payment Mode:
                        {{ item?.paymentDetailsSchema.modeOfPaymentOrPayout }}
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div class="line">{{ item?.label }}</div>
                      <div class="line">
                        Country: {{ item?.fieldSchemaValues[0].value }}
                      </div>
                      <div class="line">
                        Payment Mode:
                        {{ item?.paymentDetailsSchema.modeOfPaymentOrPayout }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div
                *ngIf="showWarningMessage"
                style="margin-top: 16px; cursor: pointer"
              >
                <a
                  class="alert alert-warning d-flex align-items-center mb-0 text-dark"
                  role="alert"
                  (click)="gotoReceiverDetails('update')"
                >
                  <span class="icon mdi mdi-alert me-2"></span>
                  <span>Please Add Payment Details for Receiver</span>
                  <i
                    class="fa fa-arrow-right font-size-13"
                    style="position: absolute; right: 8px"
                  >
                  </i>
                </a>
              </div>
            </ng-container>

            <ng-container
              *ngIf="loginType == 'PARTNER' || loginType == 'CUSTOMER'"
            >
              <label>Purpose</label>
              <div class="select-purpose" id="purpose">
                <ng-select
                  [items]="purposeList"
                  bindLabel="reason"
                  bindValue="id"
                  formControlName="purposeId"
                  [virtualScroll]="true"
                  [clearable]="false"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.reason }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.reason }}
                  </ng-template>
                </ng-select>
              </div>
            </ng-container>
          </ng-container>

          <div class="fee-breakdown border" *ngIf="false">
            <ng-container *ngIf="estimateDetails?.chargeDescAdmin">
              <div
                *ngFor="
                  let item of getFormattedChargeDesc(
                    estimateDetails.chargeDescAdmin
                  )
                "
                class="charge-row"
              >
                <span>{{ item.key }}</span>
                <span>{{
                  item.value
                    | currency
                      : estimateDetails?.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2"
                }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="estimateDetails?.chargeDescPtnrSlf">
              <div
                *ngFor="
                  let item of getFormattedChargeDesc(
                    estimateDetails.chargeDescPtnrSlf
                  )
                "
                class="charge-row"
              >
                <span>{{ item.key }}</span>
                <span>{{
                  item.value
                    | currency
                      : estimateDetails?.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2"
                }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="estimateDetails?.chargeDescPtnrTpt">
              <div
                *ngFor="
                  let item of getFormattedChargeDesc(
                    estimateDetails.chargeDescPtnrTpt
                  )
                "
                class="charge-row"
              >
                <span>{{ item.key }}</span>
                <span>{{
                  item.value
                    | currency
                      : estimateDetails?.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2"
                }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="estimateDetails?.chargeDescCstmr">
              <div
                *ngFor="
                  let item of getFormattedChargeDesc(
                    estimateDetails.chargeDescCstmr
                  )
                "
                class="charge-row"
              >
                <span>{{ item.key }}</span>
                <span>{{
                  item.value
                    | currency
                      : estimateDetails?.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2"
                }}</span>
              </div>
            </ng-container>
            <div class="total">
              <span>Total charge</span
              ><span>{{
                estimateDetails?.totalCharge
                  ? (estimateDetails?.totalCharge
                    | currency
                      : estimateDetails?.inGressCurrencyISO3
                      : "symbol"
                      : "1.2-2")
                  : "0.00"
              }}</span>
            </div>
          </div>

          <div class="button-group">
            <button
              type="button"
              class="send-btn btn btn-primary"
              *ngIf="
                estimateDetails &&
                showCreateTransaction && 
                (loginType == 'PARTNER' || loginType == 'CUSTOMER')
              "
              [disabled]="
                isLoading ||
                !estimateForm.controls['paymentDetailsValueId'].value ||
                !estimateForm.controls['purposeId'].value || error
              "
              (click)="onCreateTransaction()"
              id="sendMoney"
            >
              <ng-container *ngIf="!isLoading">Send money</ng-container>
              <ng-container *ngIf="isLoading">
                <span
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </ng-container>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- end card-body-->
</div>
<!-- end card -->

<ng-template #estimateModal role="document" let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="modalRef?.hide()"
    ></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="estimateForm">
      <div class="p-2">
        <div class="row">
          <div
            class="common-select"
            [class.col-12]="isWideScreen"
            [class.col-12]="!isWideScreen"
            *ngIf="showField == 'payment'"
          >
            <div class="mb-5">
              <label for="modeOfPaymentName"> Mode Of Payment </label>
              <ng-select
                [items]="modeOfPaymentList"
                bindLabel="name"
                bindValue="name"
                formControlName="modeOfPaymentName"
                [virtualScroll]="true"
                id="modeOfPaymentName"
                placeholder="Select  Mode Of Payment"
                [clearable]="true"
                (change)="getPaymentValue($event)"
              ></ng-select>
            </div>
          </div>

          <div
            class="common-select"
            [class.col-12]="isWideScreen"
            [class.col-12]="!isWideScreen"
            *ngIf="showField == 'payout'"
          >
            <div class="mb-5">
              <label for="modeOfPayoutName"> Mode Of Payout</label>
              <ng-select
                [items]="modeOfPayoutList"
                bindLabel="name"
                bindValue="name"
                formControlName="modeOfPayoutName"
                [virtualScroll]="true"
                id="modeOfPayoutName"
                placeholder="Select Mode Of Payout"
                [clearable]="true"
                (change)="getPaymentValue($event)"
              >
              </ng-select>
            </div>
          </div>

          <div
            class="common-select"
            [class.col-12]="isWideScreen"
            [class.col-12]="!isWideScreen"
            *ngIf="showField == 'receiver'"
          >
            <div class="mb-5">
              <label for="receiverUserId"> Receiver</label>
              <ng-select
                [items]="receiver$ | async"
                bindLabel="name"
                bindValue="id"
                formControlName="receiverUserId"
                [virtualScroll]="true"
                [typeahead]="receiverSearch$"
                (scrollToEnd)="receiverScroll()"
                id="receiverUserId"
                placeholder="Select Receiver"
                (change)="getPaymentValue($event)"
                [clearable]="true"
              >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }} ( {{ item.customerUserCode }} )
                </ng-template>
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span
                    class="ng-value-label"
                    *ngIf="item.value || item.customerUserCode"
                    >{{ item.name }} ({{ item.customerUserCode }})</span
                  >
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
